<template>
  <div v-loading="showFlag">
    <t-card class="card_common">
      <div>
        <!-- ボタン -->
        <t-row>
          <t-col :span="8" class="col_common_center">
            <!-- 新規 -->
            <t-button
              round
              type="primary"
              ref="addBtn"
              class="button_common"
              @click="addClick()"
            >
              <i class="el-icon-plus"></i>
              {{ $t("resource.sys.newBuilt") }}
            </t-button>
          </t-col>

          <t-col :span="8" class="col_common_center">
            <!-- 削除 -->
            <t-button
              round
              type="danger"
              ref="delBtn"
              class="button_common"
              @click="deleteClick()"
            >
              <i class="el-icon-delete"></i>
              {{ $t("resource.sys.delete") }}
            </t-button>
          </t-col>
        </t-row>

        <!-- 検索条件 -->
        <div class="div_common_search">
          <t-divider>{{ $t("resource.sys.searchCondition") }}</t-divider>
          <div class="search">
            <t-form
              :model="searchConditionForm"
              :label-width="$t('widgetSize.search.labelWidth')"
              @submit.native.prevent
            >
              <t-row>
                <t-col :span="1">&nbsp;</t-col>
                <t-col :span="17" class="col_block_left">
                  <!-- 検索キー -->
                  <t-form-item :label="$t('resource.sys.searchKey')">
                    <t-input
                      v-model="searchConditionForm.searchWord"
                      clearable
                      maxLength="50"
                      class="input_searchKey"
                    >
                    </t-input>
                  </t-form-item>
                </t-col>
                <t-col :span="1" class="col_block_left">&nbsp;</t-col>
                <t-col :span="5" class="col_common_left">
                  <!-- 検索 -->
                  <t-button
                    round
                    ref="searchBtn"
                    type="primary"
                    class="button_common_search"
                    @click="searchClick()"
                  >
                    <i class="el-icon-search"></i
                    >{{ $t("resource.sys.search") }}
                  </t-button>
                </t-col>
              </t-row>
            </t-form>
          </div>
        </div>
      </div>
      <div class="div_content">
        <t-table
          ref="userManageData"
          :data="tableData"
          class="table_common"
          header-cell-class-name="bg-default"
          @row-dblclick="detailClick"
          :height="maxheight"
          border
        >
          <t-table-column type="selection" class-name="cell_txt_center" />

          <t-table-column
            v-for="(column, index) in columns"
            :key="index"
            :type="column.type"
            :prop="column.prop"
            :label="column.label"
            :min-width="column.width"
            :class-name="column.class"
            :show-overflow-tooltip="column.overflowTooltip"
          >
            <template slot-scope="scope">
              <span v-if="column.prop === 'Password'"> ******* </span>

              <span v-else>
                {{ scope.row[column.prop] }}
              </span>
            </template>
          </t-table-column>
        </t-table>

        <t-pagination
          align="right"
          :current-page.sync="pageNo"
          :page-size="pageSize"
          :page-sizes="getPageDataCountFunc()"
          layout="total, sizes, prev, pager, next"
          :total="tableDatalength"
          @current-change="pageChange"
          @size-change="handleSizeChange"
        >
        </t-pagination>
      </div>
    </t-card>
  </div>
</template>

<script>
import { getUserInfo } from "@/auth";
import { ShowUserDialog } from "@/components/Dialog";
import { t } from "@/locales";
import service from "@/services/userManage";
import { GetPageDataCount } from "@/utils/const";
import { setColumnWidth } from "@/utils/table";
import { Message, Modal } from "@tellus/component";
export default {
  name: "UserManage",
  data() {
    return {
      dateRange: [],

      maxheight: window.innerHeight - 291.5 + 35, //291.5 = 165.5 + 20 + 10 + 58 + 32 + 6
      searchConditionForm: {
        searchWord: "",
        usrEndDate: "",
        usrStartDate: "",
        deleteFlg: "",
        //usrRole: "",
      },

      // 一览数据
      userManageData: [],

      //担当者
      userList: [],

      tableDatalength: 0,

      usrRolesList: [],

      useFlgs: [],

      columns: [
        // ユーザID
        {
          prop: "userId",
          label: t("resource.userMst.usrCode"),
          width: t("widgetSize.tableCommon.width80"),
          class: "cell_txt_left",
          overflowTooltip: false,
        },
        // ユーザー名
        {
          prop: "userName",
          label: t("resource.userMst.usrName"),
          width: t("widgetSize.tableCommon.defaultWidth"),
          class: "cell_txt_left",
          overflowTooltip: false,
        },

        // ニック名
        {
          prop: "nickName",
          label: t("resource.userMst.nickName"),
          width: t("widgetSize.tableCommon.defaultWidth"),
          class: "cell_txt_left",
          overflowTooltip: false,
        },

        // 省略字
        {
          prop: "contraction",
          label: t("resource.userMst.contraction"),
          width: t("widgetSize.tableCommon.width60"),
          class: "cell_txt_left",
          overflowTooltip: false,
        },

        // 部門
        {
          prop: "departmentStr",
          label: t("resource.userMst.department"),
          width: t("widgetSize.tableCommon.width80"),
          class: "cell_txt_left",
          overflowTooltip: false,
        },

        // // パスワード
        // {
        //   prop: "Password",
        //   label: t("resource.userMst.usrPwd"),
        //   type: "password",
        //   width: t("widgetSize.tableCommon.defaultWidth"),
        //   class: "cell_txt_center",
        //   overflowTooltip: false,
        // },

        // 電話番号
        {
          prop: "telephone",
          label: t("resource.userMst.telephone"),
          width: t("widgetSize.tableCommon.defaultWidth"),
          class: "cell_txt_left",
          overflowTooltip: true,
        },

        // メール
        {
          prop: "email",
          label: t("resource.userMst.usrMail"),
          width: t("widgetSize.tableCommon.width150"),
          class: "cell_txt_left",
          overflowTooltip: true,
        },

        // // 権限
        // {
        //   prop: "Auths",
        //   label: t("resource.userMst.usrRole"),
        //   width: t("widgetSize.tableCommon.defaultWidth"),
        //   class: "cell_txt_center",
        //   overflowTooltip: false,
        // },

        // 使用区分
        {
          prop: "userFlgStr",
          label: t("resource.userMst.usrFlag"),
          width: t("widgetSize.tableCommon.defaultWidth"),
          class: "cell_txt_center",
          overflowTooltip: true,
        },
      ],

      // 检索
      search: "",

      pageNo: 1,
      pageSize: 20,
      showFlag: false,
    };
  },
  computed: {
    tableData() {
      return this.userManageData.slice(
        (this.pageNo - 1) * this.pageSize,
        this.pageNo * this.pageSize
      );
    },
  },
  mounted() {
    this.showFlag = true;

    //画面の初期化
    this.init();

    //テーブルの高さを監視する
    window.addEventListener("resize", this.handleResize);

    setColumnWidth(this.columns, this.userManageData);
  },
  methods: {
    //テーブルの高さを設定する
    handleResize() {
      this.maxheight = window.innerHeight - 291.5 + 35; //291.5 = 165.5 + 20 + 10 + 58 + 32 + 6
    },

    // 初期化
    init() {
      this.showFlag = true;

      this.searchClick();
    },

    // 新規
    addClick() {
      // フォーカス削除
      this.$refs.addBtn.$el.blur();
      ShowUserDialog(
        {
          isAdd: true,
          useFlgs: this.useFlgs,
        },
        t("resource.userManager.userCreateView"),
        this.searchClick
      );
    },

    //検索
    searchClick() {
      //スペースを削除
      this.searchConditionForm.searchWord =
        this.searchConditionForm.searchWord.trim();

      //検索
      service
        .GetUserInfoData(this.searchConditionForm)
        .then((res) => {
          // console.log(res);

          Message.showSuccess(t("message.COMMON_MESSAGE.SEARCH_SUCCESS"));

          //使用区分リスト
          this.useFlgs = res.UseFlgs;

          //一覧表のデータ
          this.userManageData = res.UserMstDtos;

          //データ処理
          this.dataProcess();

          this.tableDatalength = this.userManageData.length;

          setColumnWidth(this.columns, this.userManageData);
        })
        .catch((err) => {
          if (err.data != null) {
            Message.showError(
              t("message.COMMON_MESSAGE." + err.data.Messages[0].Message)
            );
          } else {
            Message.showError(t("message.COMMON_MESSAGE.SEARCH_FAILURE"));
          }
        })
        .finally(() => {
          this.showFlag = false;
        });

      if (typeof this.$refs.searchBtn !== "undefined") {
        // フォーカス削除
        this.$refs.searchBtn.$el.blur();
      }
    },

    //データ処理
    dataProcess() {
      this.userManageData.forEach((item) => {
        //使用区分
        item.DeleteFlg = this.useFlgs.find(
          (flag) => flag.value === item.DeleteFlg
        )?.label;
      });
    },

    //ユーザ編集画面
    detailClick(row) {
      ShowUserDialog(
        {
          isAdd: false,
          rowData: row,
          useFlgs: this.useFlgs,
        },
        t("resource.userManager.userEditView"),
        this.searchClick
      );
    },

    // 削除
    deleteClick() {
      // フォーカス削除
      this.$refs.delBtn.$el.blur();
      let data = this.$refs.userManageData.selection;

      if (data.length >= 1) {
        let delList = [];
        for (let index = 0; index < data.length; index++) {
          delList.push(data[index].userId);
        }
        Modal.showWarning("", t("resource.sys.deleteMessage"), {
          $type: "prompt",
          confirmButtonText: t("resource.button.sure"),
          cancelButtonText: t("resource.button.cancel"),
          showCancelButton: true,
        }).then(() => {
          // 削除ユーザー情報
          service
            .DelUserInfoData({
              delList: delList,
              user: getUserInfo().userId,
            })
            .then(() => {
              Message.showSuccess(t("message.COMMON_MESSAGE.DELETE_SUCCESS"));
            })
            .catch((err) => {
              if (err.data != null) {
                Message.showError(
                  t("message.COMMON_MESSAGE." + err.data.Messages[0].Message)
                );
              } else {
                Message.showError(t("message.COMMON_MESSAGE.DELETE_FAILURE"));
              }
            })
            .finally(() => {
              //検索処理を行う
              this.searchClick();
            });
        });
      } else {
        Modal.showWarning("", t("message.COMMON_MESSAGE.PLEASE_SELECT_DATA"), {
          confirmButtonText: t("resource.COMMON_CONSTANT.CONFIRM"),
        });
      }
    },

    pageChange(val) {
      this.pageNo = val;
    },

    handleSizeChange(val) {
      this.pageNo = 1;
      this.pageSize = val;
    },

    getPageDataCountFunc() {
      return GetPageDataCount();
    },
  },
};
</script>
<style scoped>
::v-deep .page-title svg {
  top: 3px !important;
  width: 20px !important;
  height: 20px !important;
}
</style>
